import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mortgageFields"];

  connect() {
    this.toggle();
  }

  toggle() {
    const radios = this.element.querySelectorAll(
      "input[type='radio'][name$='[mortgage]']"
    );

    let checkedRadio = null;
    for (const radio of radios) {
      if (radio.checked) {
        checkedRadio = radio;
        break;
      }
    }

    const hasMortgage = checkedRadio && checkedRadio.value === "true";
    const inputs = this.mortgageFieldsTarget.querySelectorAll(
      "input[type='number']"
    );

    if (hasMortgage) {
      this.mortgageFieldsTarget.classList.remove("hidden");
      for (const input of inputs) {
        input.disabled = false;
        input.required = true;
      }
    } else {
      this.mortgageFieldsTarget.classList.add("hidden");
      for (const input of inputs) {
        input.disabled = true;
        input.required = false;
        input.value = "";
      }
    }
  }
}
